import {
  faEye,
  faEyeSlash,
  faLock,
  faMobileAlt,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import md5 from "blueimp-md5";
import React from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { removeAuth, setAuth } from "../authSlice";
import { saveJournal } from "../commonFetch";
import ToBack from "../components/ToBack";
import reducer from "../reducer";

export default function LogIn() {
  const [state, dispatch] = React.useReducer(reducer, {
    username: "",
    password: "",
    phone: "",
    code: "",
  });
  const id = new URLSearchParams(useLocation().search).get("id");
  const [hide, setHide] = React.useState(true);
  const [loginType, setLoginType] = React.useState("password"); // password or phone
  const [countdown, setCountdown] = React.useState(0);
  const timerRef = React.useRef(null);
  const reduxDispatch = useDispatch();

  const handleSignIn = () => {
    if (loginType === "password") {
      fetch("/gin-api/candidate/login", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          username: state.username,
          password: md5(state.password),
        }),
      })
        .then(async (response) => {
          if (200 === response.status) return response.json();
          if (401 === response.status) {
            const data = await response.json();
            throw new Error(data.title || "账号或密码错误");
          }
          throw new Error("账号或密码错误");
        })
        .then(handleLoginSuccess)
        .catch((err) => alert(err));
    } else {
      fetch("/gin-api/candidate/login-by-phone-code", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          phone: state.phone,
          code: state.code,
        }),
      })
        .then(async (response) => {
          if (response.ok) return response.json();
          if (401 === response.status) {
            const data = await response.json();
            throw new Error(data.title || "手机号或验证码错误");
          }
          throw new Error("手机号或验证码错误");
        })
        .then(handleLoginSuccess)
        .catch((err) => alert(err));
    }
  };

  const handleLoginSuccess = (data) => {
    localStorage.setItem("auth", JSON.stringify(data));
    reduxDispatch(setAuth(data));
    saveJournal({
      ref_id: data.id,
      ref_id2: 0,
      category: "登录",
      tag: "个人用户",
      ref_uuid: data.uuid,
      ref_uuid2: "",
    });
    if (id !== null) {
      window.history.back();
    } else {
      location.href = "#/";
    }
  };

  const checkPhone = () => {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
    return reg.test(state.phone);
  };

  const handleSendCode = async () => {
    if (!checkPhone()) {
      alert("请输入正确的手机号");
      return;
    }

    try {
      const response = await fetch(`/gin-api/candidate?option=by-phone&phone=${state.phone}`);
      const user = await response.json();
      if (!user) {
        alert("该手机号码未注册");
        throw new Error("该手机号码未注册");
      }
    } catch (err) {
      console.error(err);
      return;
    }
    fetch("/gin-api/ephemeral/phone", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        phone: state.phone,
        purpose: "登录",
      }),
    })
      .then((response) => {
        if (response.ok) {
          setCountdown(60);
          if (timerRef.current) {
            clearInterval(timerRef.current);
          }
          timerRef.current = setInterval(() => {
            setCountdown((prev) => {
              if (prev <= 1) {
                clearInterval(timerRef.current);
                timerRef.current = null;
                return 0;
              }
              return prev - 1;
            });
          }, 1000);
        } else {
          throw new Error("发送失败，请稍后重试");
        }
      })
      .catch((err) => alert(err));
  };

  const onHide = (e) => {
    setHide(e);
  };

  React.useEffect(() => {
    localStorage.removeItem("auth");
    reduxDispatch(removeAuth());

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  return (
    <>
      <div className="container-fluid background-login">
        <ToBack href="#" />
        <div className="mt-4 bg-transparent text-white pt-5 text-center">
          <h4>
            <strong className="text-warning">Hi</strong>
            &nbsp;&nbsp;龙江学子就业平台
          </h4>
        </div>

        <div className="row mt-3 bg-transparent text-dark">
          <div className="col">
            <div className="card border-0 bg-transparent text-dark">
              <div className="card-body">
                <div className="mb-3 text-center">
                  <button
                    className={`btn btn-sm mr-2 ${loginType === "password" ? "btn-warning" : "btn-outline-light"}`}
                    onClick={() => setLoginType("password")}
                  >
                    账号密码登录
                  </button>
                  <button
                    className={`btn btn-sm ${loginType === "phone" ? "btn-warning" : "btn-outline-light"}`}
                    onClick={() => setLoginType("phone")}
                  >
                    手机验证码登录
                  </button>
                </div>

                {loginType === "password" ? (
                  <>
                    <div className="input-group mb-3 input-group-lg input-control">
                      <div className="input-group-prepend">
                        <span className="input-group-text bg-transparent text-white border-0">
                          <FontAwesomeIcon icon={faUserCircle} fixedWidth />
                        </span>
                      </div>
                      <input
                        type="text"
                        value={state.username}
                        className="form-control bg-transparent text-white border-0 input-placeholder input-f"
                        placeholder="手机号码/邮箱"
                        onChange={(e) =>
                          dispatch({
                            type: "set",
                            payload: { key: "username", value: e.target.value },
                          })
                        }
                      />
                    </div>
                    <div className="input-group mb-3 input-group-lg input-control">
                      <div className="input-group-prepend">
                        <span className="input-group-text bg-transparent text-white border-0">
                          <FontAwesomeIcon icon={faLock} fixedWidth />
                        </span>
                      </div>
                      <input
                        type={hide ? "password" : "text"}
                        value={state.password}
                        className="form-control bg-transparent text-white border-0 input-placeholder input-f"
                        placeholder="登录密码"
                        onChange={(e) =>
                          dispatch({
                            type: "set",
                            payload: { key: "password", value: e.target.value },
                          })
                        }
                      />
                      {hide ? (
                        <div className="input-group-append">
                          <span
                            className="input-group-text bg-transparent text-white border-0"
                            onClick={() => onHide(false)}
                          >
                            <FontAwesomeIcon icon={faEyeSlash} fixedWidth />
                          </span>
                        </div>
                      ) : (
                        <div className="input-group-append">
                          <span
                            className="input-group-text bg-transparent text-white border-0"
                            onClick={() => onHide(true)}
                          >
                            <FontAwesomeIcon icon={faEye} fixedWidth />
                          </span>
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="input-group mb-3 input-group-lg input-control">
                      <div className="input-group-prepend">
                        <span className="input-group-text bg-transparent text-white border-0">
                          <FontAwesomeIcon icon={faMobileAlt} fixedWidth />
                        </span>
                      </div>
                      <input
                        type="text"
                        value={state.phone}
                        className="form-control bg-transparent text-white border-0 input-placeholder input-f"
                        placeholder="手机号码"
                        onChange={(e) =>
                          dispatch({
                            type: "set",
                            payload: { key: "phone", value: e.target.value },
                          })
                        }
                      />
                    </div>
                    <div className="input-group mb-3 input-group input-control">
                      <div className="input-group-prepend">
                        <span className="input-group-text bg-transparent text-white border-0">
                          <FontAwesomeIcon icon={faLock} fixedWidth />
                        </span>
                      </div>
                      <input
                        type="text"
                        value={state.code}
                        className="form-control bg-transparent text-white border-0 input-placeholder input-f"
                        placeholder="验证码"
                        onChange={(e) =>
                          dispatch({
                            type: "set",
                            payload: { key: "code", value: e.target.value },
                          })
                        }
                      />
                      <div className="input-group-append">
                        <button
                          type="button"
                          className="btn btn-outline-light btn-sm"
                          onClick={handleSendCode}
                          disabled={countdown > 0 || !checkPhone()}
                          style={{
                            fontSize: "14px",
                            padding: "2px 4px",
                            lineHeight: "0",
                          }}
                        >
                          {countdown > 0 ? `${countdown}秒后重试` : "发送验证码"}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="form-group">
                <button
                  type="button"
                  style={{ width: "85%" }}
                  className="btn btn-block mx-auto rounded-pill button-background text-white font-weight"
                  onClick={handleSignIn}
                >
                  登&nbsp;录
                </button>
              </div>
              <div
                style={{
                  width: "95%",
                  fontSize: 13,
                }}
                className="row mx-auto"
              >
                <div className="col text-center">
                  <a className="text-white font-weight" href="#/注册">
                    立即注册&nbsp;
                  </a>
                  <span className="text-white font-weight">|</span>
                  <a className="text-warning font-weight" href="#/忘记密码">
                    &nbsp;忘记密码
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
